import { render } from "./Background.vue?vue&type=template&id=56cedd9c"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"
script.render = render

export default script